import React from "react";
import { Col, Form, Input } from "antd";
import { Rule } from "antd/es/form";
import { InputProps } from "antd/es/input";

interface ScaleInputProps extends InputProps {
    name: string;
    label?: string;
    span?: number;
    rules?: Rule[];
    hidden?: boolean;
    extra?: React.ReactNode;
    extraWidth?: string;
    dark?: boolean; // Add this prop
}

const ScaleInput: React.FC<ScaleInputProps> = ({
                                                   name,
                                                   label,
                                                   span,
                                                   rules,
                                                   hidden,
                                                   extra,
                                                   extraWidth,
    dark,
                                                   ...rest
                                               }) => {
    if (hidden) {
        return (
            <Form.Item noStyle name={name}>
                <Input hidden={true}  {...rest} />
            </Form.Item>
        );
    }

    if (extra) {
        return (
            <Col span={span}>
                <Form.Item name={name} label={label} rules={rules}>
                    <Input.Group compact>
                        <Form.Item noStyle name={name}>
                            <Input {...rest} style={{ width: `calc(100% - ${extraWidth})` }} />
                        </Form.Item>
                        {extra}
                    </Input.Group>
                </Form.Item>
            </Col>
        );
    }

    return (
        <Col span={span}>
            <Form.Item name={name} label={label} rules={rules}>
                <Input {...rest} />
            </Form.Item>
        </Col>
    );
};

export default ScaleInput;